import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithImageResetPassword() {
	return <AuthShell variant="with-image"><AuthForm variant="with-image" mode="reset-password" /></AuthShell>;
}

export default AuthWithImageResetPassword;
